import { PointSymbolType, MaskedImageSymbol, PolylineSymbol, PolygonSymbol } from "../../../interfaces/style";

export const enum LegendSymbolTypes {
  Point,
  ImagePoint,
  Line,
  Polygon,
}

type LegendSymbolsMap = {
  [LegendSymbolTypes.Point]: PointSymbolType;
  [LegendSymbolTypes.ImagePoint]: MaskedImageSymbol;
  [LegendSymbolTypes.Line]: PolylineSymbol;
  [LegendSymbolTypes.Polygon]: PolygonSymbol;
};

export const SYMBOL_SIZE_PARAMETERS = ["size", "width", "height"];

// Основывается на http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217 -> пункт "Библиотека символов"
export const DEFAULT_LEGEND_SIZES: Record<PointSymbolType["type"], number> = {
  circlePointSymbol: 8,
  squarePointSymbol: 12,
  imagePointSymbol: 24,
  maskedImagePointSymbol: 24,
  svgPointSymbol: 24,
};

// Основывается на http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217 ->
// пункт "Настраиваемые значения параметров символики в системе"
// Для добавления подготовленных значений размеров символов нужно использовать константу PREPARED_SYMBOL_SIZES
export const DEFAULT_LEGEND_STYLES: LegendSymbolsMap = {
  [LegendSymbolTypes.Point]: {
    fillColor: "#00000047",
    strokeWidth: 1,
    strokeColor: "#0000001f",
  },
  [LegendSymbolTypes.ImagePoint]: {
    maskedColor: "#00000047",
  },
  [LegendSymbolTypes.Line]: {
    stroke: {
      width: 2,
      color: "#00000047",
    },
  },
  [LegendSymbolTypes.Polygon]: {
    fill: {
      color: "#00000000",
      hatchColor: "#00000000",
    },
    stroke: {
      width: 1,
      color: "#0000001f",
    },
  },
};
